<template>
  <header class="header" :style="`backgroundImage: url('${headline_image}')`">
    <section class="header__content">
      <div class="header__question">Question:</div>
      <h1 class="header__questionText">{{ question }}</h1>
    </section>
    <a href="/">
      <div class="logo header__logo" role="img" aria-label="TriviaPop"></div>
    </a>
  </header>
</template>

<script>
export default {
  name: "SiteHeader",
  props: ["question", "headline_image"]
};
</script>

<style scoped lang="scss">
  .header {
    display: flex;
    padding: 3.2rem 4.5rem 3.2rem;
    text-align: center;
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: $black;
    background-position: top center;
    min-height: 20rem;
    @media ($medium) {
      padding: 9rem 15% 16rem;
      background-size: auto 100%;
      min-height: 35rem;
    }
    @media ($large) {
      min-height: 32rem;
      padding: 9rem 12% 16rem;
    }
    @media ($x-large) {
      padding-bottom: 17rem;
      background-size: 65% auto;
    }
    &::before {
      position: absolute;
      content:"";
      top:0;
      left: 0;
      right:0;
      height:80%;
      background-color: rgba(0, 0, 0, 0.5);
    }
    &::after {
      position: absolute;
      content:"";
      bottom:0;
      left: 0;
      right:0;
      height:20%;
      background-image: linear-gradient(to top, #000000, rgba(0, 0, 0, 0.5));
    }
    &__content {
      margin: auto;
    }
    &__logo {
      @extend %large-logo;
      bottom: -5rem;
    }
    &__question {
      text-transform: uppercase;
      font-weight: 500;
      font-size: 1.2rem;
      margin-bottom: .48rem;
      position: relative;
      z-index: 1;
      @media ($medium) {
        font-size: 2.1rem;
      }
    }
    &__questionText {
      @extend %max-trivia-page-width;
      color: $white;
      font-size: 2.3rem;
      font-weight: bold;
      line-height: 1.04;
      text-shadow: 1px 2px 2px rgba(0, 0, 0, 0.5);
      position: relative;
      z-index: 1;
      @media ($medium) {
        font-size: 4.03rem;
      }
      @media ($large) {
        max-width: 58rem;
      }
    }
  }
</style>
